import {Injectable} from '@angular/core';
import {Grossempfaengeradresse, StammdatenAdresse} from '@nachdigal';
import {AbstractMapper} from '../../abstract.mapper';

@Injectable()
export class GrossempfaengerMapperService extends AbstractMapper<StammdatenAdresse, Grossempfaengeradresse> {

  public mapArray(source: Array<StammdatenAdresse>): Array<Grossempfaengeradresse> {
    return super.mapArray(source?.filter(value => value.typ === StammdatenAdresse.TypEnum.NUMBER_3));
  }

  public getMappedArrayDefaultIndex(source: Array<StammdatenAdresse>): number {
    return source.filter(value => value.typ === StammdatenAdresse.TypEnum.NUMBER_3)
      .findIndex(value => value.standard);
  }

  protected mapInternal(source: StammdatenAdresse): Grossempfaengeradresse {

    if (source.typ !== StammdatenAdresse.TypEnum.NUMBER_3) {
      return undefined;
    }

    return {
      ort: source.grossempfaenger.ort,
      postleitzahl: source.grossempfaenger.postleitzahl
    };
  }
}
